"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightInformation = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const DateTime_1 = require("../../../../../DateTime");
const Icon_1 = require("../../../../../Icon");
const MultiLanguage_1 = require("../../../../../MultiLanguage");
const Sub_1 = require("../../../../../Page/Title/Sub");
require("./index.scss");
const className = 'flight-list-info-flight-information';
const FlightInformation = (props) => {
    const { flight } = props;
    if (!flight)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'airplane', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:FlightInformation', defaultMessage: 'Flight information' }), modificators: 'margin-bottom-sm' }),
        react_1.default.createElement("div", { className: `${className}__summary` },
            react_1.default.createElement("span", { className: `${className}__summary-item` },
                "ID ",
                flight.id),
            react_1.default.createElement("span", { className: `${className}__summary-item` },
                react_1.default.createElement(DateTime_1.DateTime, { value: flight.departure, isLocalTime: true })),
            react_1.default.createElement("span", { className: `${className}__summary-item ${className}__summary-item--number` }, flight.number),
            react_1.default.createElement("span", { className: `${className}__summary-item` },
                react_1.default.createElement("div", { className: `${className}__airport` }, flight.origin.name
                    ? (react_1.default.createElement(MultiLanguage_1.MultiLanguage, { value: flight.origin.name }))
                    : flight.origin.code),
                react_1.default.createElement(Icon_1.Icon, { name: 'airplane-horisontal' }),
                react_1.default.createElement("div", { className: `${className}__airport` }, flight.destination.name
                    ? (react_1.default.createElement(MultiLanguage_1.MultiLanguage, { value: flight.destination.name }))
                    : flight.destination.code)))));
};
exports.FlightInformation = FlightInformation;
//# sourceMappingURL=index.js.map